import { render } from "./step6.vue?vue&type=template&id=487ea450&scoped=true"
import script from "./step6.vue?vue&type=script&lang=ts"
export * from "./step6.vue?vue&type=script&lang=ts"

import "./step6.vue?vue&type=style&index=0&id=487ea450&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-487ea450"

export default script